import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'accent' | 'danger' | 'outline';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'accent',
  title,
  lead,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-4xl text-center' : 'max-w-4xl';
  return <div className={`${alignment} ${className}`} data-id="element-219" data-mp="gj6uf9x23bif">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-220" data-mp="gion9i8uvcvq">{eyebrow}</Pill> : null}
      <h2 className={`font-display text-[2.4rem] font-extrabold uppercase leading-[0.95] text-fg sm:text-5xl lg:text-[3.5rem] ${eyebrow ? 'mt-3' : ''}`} data-id="element-221" data-mp="1vc0jq7bb13r">
        {title}
      </h2>
      {lead ? <p className={`mt-3 text-lg leading-relaxed text-muted ${align === 'center' ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`} data-id="element-222" data-mp="uippb10uwqcs">
          {lead}
        </p> : null}
    </div>;
}